import CourseCompletionRateComparisonBarChart from 'widgets/CourseCompletionRateComparisonBarChart/CourseCompletionRateComparisonBarChart'

export default CourseCompletionRateComparisonBarChart
